import { Badge } from "@/components/common";
import HeroAbout from "@/components/common/HeroAbout";
import Container from "@/components/layout/Container";
import { patents as patentData } from "@/constants";

interface PatentItem {
  title: string;
  number: string;
  date: string;
}

const techCards = [
  {
    enTitle: "Dynamic Email Solution",
    koTitle: "다이나믹 메일 솔루션",
    image: "/img/about/tech_dynamic.jpg",
  },
  {
    enTitle: "Multimedia Messaging Solution",
    koTitle: "멀티미디어 메시징 솔루션",
    image: "/img/about/tech_multimedia.jpg",
  },
  {
    enTitle: "High-Capacity Messaging Solution",
    koTitle: "대용량 메시지 솔루션",
    image: "/img/about/tech_highCapacity.jpg",
  },
  {
    enTitle: "Online Cash Solution",
    koTitle: "온라인 캐쉬 솔루션",
    image: "/img/about/tech_onlineCash.jpg",
  },
  {
    enTitle: "Security SMS Solution",
    koTitle: "보안 SMS 솔루션",
    image: "/img/about/tech_securitySMS.jpg",
  },
];

const AboutTechnology = () => {
  return (
    <Container>
      <HeroAbout />

      <div className="py-[30px] px-[2rem] wide:px-0">
        {/* Tech Section */}
        <section className="mb-20">
          <h2 className="text-[2.8rem] font-bold mb-10 pb-6 border-b-2 border-black/60 text-left">
            보유 기술
          </h2>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
            {techCards.map((card, idx) => (
              <div key={idx} className="bg-white rounded-2xl overflow-hidden ">
                <span className="block py-3 text-[1.2rem] text-gray-5">{card.enTitle}</span>
                <div>
                  <img
                    src={card.image}
                    alt={card.koTitle}
                    className="object-cover w-full h-[150px]"
                    loading="lazy"
                  />
                </div>
                <p className="px-4 pt-4 text-[1.5rem] font-medium text-center">{card.koTitle}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Patent Section */}
        <section>
          <h2 className="text-[2.8rem] font-bold mb-10 pb-6 border-b-2 border-black/60 text-left">
            보유 특허 사항
          </h2>
          <div className="overflow-x-auto">
            <table className="w-full min-w-[600px]">
              <thead>
                <tr className="">
                  <th className="py-4 px-4 text-left text-[1.5rem] font-semibold bg-gray-50 w-[60px]">
                    No
                  </th>
                  <th className="py-4 px-4 text-left text-[1.5rem] font-semibold bg-gray-50">
                    특허 제목
                  </th>
                  <th className="py-4 px-4 text-left text-[1.5rem] font-semibold bg-gray-50 w-[180px]">
                    특허 번호
                  </th>
                  <th className="py-4 px-4 text-left text-[1.5rem] font-semibold bg-gray-50 w-[140px]">
                    등록일
                  </th>
                </tr>
              </thead>
              <tbody>
                {patentData?.map((patent, idx) => (
                  <tr key={idx} className="border-b border-gray-2 ">
                    <td className="py-4 px-4 text-[1.4rem] text-gray-6">{idx + 1}</td>
                    <td className="py-4 px-4 text-[1.4rem] text-gray-7">{patent.title}</td>
                    <td className="py-4 px-4 text-[1.4rem] text-gray-6">{patent.number}</td>
                    <td className="py-4 px-4 text-[1.4rem] text-gray-6">{patent.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </Container>
  );
};

export default AboutTechnology;
